const ease = [0.4, 0, 0.2, 1];

export const pageVariants = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.22, ease } },
  exit:    { opacity: 0, y: -4, transition: { duration: 0.15, ease } },
};

export const dialogContentVariants = {
  initial: { opacity: 0, y: 10, scale: 0.98 },
  animate: { opacity: 1, y: 0,  scale: 1,    transition: { duration: 0.2, ease } },
};

export const toastVariants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0,  transition: { duration: 0.22, ease } },
};
